import { useMemo } from "react";
import { Modal, Flex, Spin } from "@/base/components/index";
import { MessageBoundary } from "@/components/message-boundary/components/message-boundary";
import { ModalFormProps } from "../types";
import { useModalFormStyles } from "./modal-form.styles";

export const ModalForm = ({
  open,
  onCancel,
  title,
  footer,
  children,
  className,
  width,
  loading,
  destroyOnHidden = true,
}: ModalFormProps) => {
  const { styles } = useModalFormStyles();

  const widthConfig = useMemo(
    () =>
      width || {
        xs: "100%",
        sm: "100%",
        md: "95%",
        lg: "70%",
        xl: "70%",
        xxl: "60%",
      },
    [width],
  );

  return (
    <Modal
      style={{ top: 12 }}
      destroyOnHidden={destroyOnHidden}
      width={widthConfig}
      open={open}
      maskClosable={false}
      className={className}
      onCancel={onCancel}
      footer={footer}
      title={title}
    >
      {loading && (
        <Flex justify="center" align="center" className={styles.loader}>
          <Spin size="large" />
        </Flex>
      )}
      <Flex vertical gap={12} align="stretch">
        <MessageBoundary level="modal" />
        {children}
      </Flex>
    </Modal>
  );
};
